module.exports = __webpack_public_path__ + "static/media/Diamond.c425ba06.svg";